module.exports = __webpack_public_path__ + "img/first_down_left.084b58b6.jpg";